import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()

export const CONTACT_PREFERENCE_TYPES = {
  // maintainanace, messages
  EMAIL: 1,
  PHONE: 2,
}

export const FEED_TYPES = {
  //  classifieds, community-feed, messages
  EVENT: {
    getLabel: () => __('Include Events'),
    getName: () => __('Events'),
    value: 'Event',
  },
  ANNOUNCEMENT: {
    getLabel: () => __('Include Announcements'),
    getName: () => __('Announcements'),
    value: 'Announcement',
  },
  CLASSIFIED: {
    getLabel: () => __('Include New Classified Items'),
    getName: () => __('Classifieds'),
    value: 'Classified',
  },
  CLUBS: {
    getLabel: () => __('Include Clubs'),
    getName: () => __('Clubs'),
    value: 'Clubs',
  },
}

// this is for mapping values from the PhoneFieldWithTypePicker
export const PHONE_TYPE_IDS = {
  // message,renewals, settings
  home: 2,
  mobile: 4,
  work: 3,
}

// this maps phone type ids to values usable in PhoneFieldWithTypePicker
export const PHONE_TYPE_VALUES = {
  //  renewals, settings
  2: 'home',
  3: 'work',
  4: 'mobile',
}

export const IMG_FILE_TYPES = [
  '.png',
  '.jpg',
  '.gif',
  '.jpeg',
  '.bmp',
  '.PNG',
  '.JPG',
  '.GIF',
  '.JPEG',
  '.BMP',
]

export const CONTACT_TYPES = {
  11: __('Billing'),
  12: __('Legal'),
  13: __('Primary'),
  15: __('Maintenance'),
}

export const ACTIVE_LEASE_COUNT = isRP ? 3 : 999999

export const GUARANTOR_TYPE_NAME = 'guarantor'
